<template>

  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <div id="right-panel" class="right-panel fContainer">

      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->

      <div class="content mt-3 fColumn">
        <div class="animated fadeIn fColumn" v-if="this.hasRole">
          <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
          <!--<form action="/" method="post" id="form" class="userForm ajaxForm     fColumn">-->
          <div class="card     fColumn ">
            <div class="card-header     fHead">
              <strong>{{$t('InvoicenInboundExport.title')}}</strong>
              <div class="float-right">
              </div>
            </div>

            <div class=" scrollHeightEnable600x fContent ">
              <div class="card-body card-block fColumn pt-0 pb-0">
                <br>
                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="file" class=" form-control-label">{{$t('uploads.selectFile')}}</label></div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<input type="file" id="file" name="file" class="form-control" multiple>-->
                <!--<span class="help-block"></span></div>-->
                <!--</div>-->

                <div class="row form-group">
                  <div class="col col-md-4"><label for="dt_from" class=" form-control-label">{{ $t('InvoicenInboundExport.dt_from') }}
                    <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                  </div>
                  <div class="col-12 col-md-8">
                    <InputText type="DatetimepickerBp"
                               id="dt_from" name="data.dt_from" v-model="data.dt_from" v-validate="'required'" hasToKeyboard="auto" value=""
                               :title="$t('InvoicenInboundExport.dt_from')"
                               placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_from')"/>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col col-md-4"><label for="dt_to" class=" form-control-label">{{ $t('InvoicenInboundExport.dt_to') }}
                    <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                  </div>
                  <div class="col-12 col-md-8">
                    <InputText type="DatetimepickerBp"
                               id="dt_to" name="data.dt_to" v-model="data.dt_to" v-validate="'required'" hasToKeyboard="auto" value=""
                               :title="$t('InvoicenInboundExport.dt_to')"
                               placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_to')"/>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col col-md-4"><label for="datetype" class=" form-control-label">{{$t('InvoicenInboundExport.datetype')}}</label></div>
                  <div class="col col-8">
                    <div class="row ">
                      <div class="w100 dateSelectsContainer">
                        <div class="col col-12">
                          <select id="datetype" v-model="data.datetype" class="form-control" name="datetype">
                            <option value="1">{{$t('invoice.dt_completion')}}</option>
                            <option value="2" selected >{{$t('invoice.dt_make')}}</option>
                            <option value="3">{{$t('invoice.dt_paymentdeadline')}}</option>
                            <option value="4">{{$t('InvoiceInbound.dt_needtransfer')}}</option>
                            <option value="5">{{$t('InvoiceInbound.dt_transfer')}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="uplselYear" class=" form-control-label">{{$t('uploads.uploadDate')}}</label></div>-->
                <!--<div class="col col-9">-->
                <!--<div class="row ">-->
                <!--<div class="w100 dateSelectsContainer">-->
                <!--<div class="col col-4">-->
                <!--<select id="uplselYear" v-model="year" class="form-control" name="uplselYear">-->
                <!--<option v-for="yearOption in yearOptions" :value="yearOption.value">{{yearOption.text}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--<div class="col col-4">-->
                <!--<select id="uplselMonth" v-model="month" class="form-control" name="uplselMonth">-->
                <!--<option value="1">{{$t('global.monthNames.January')}}</option>-->
                <!--<option value="2">{{$t('global.monthNames.February')}}</option>-->
                <!--<option value="3">{{$t('global.monthNames.March')}}</option>-->
                <!--<option value="4">{{$t('global.monthNames.April')}}</option>-->
                <!--<option value="5">{{$t('global.monthNames.May')}}</option>-->
                <!--<option value="6">{{$t('global.monthNames.June')}}</option>-->
                <!--<option value="7">{{$t('global.monthNames.July')}}</option>-->
                <!--<option value="8">{{$t('global.monthNames.August')}}</option>-->
                <!--<option value="9">{{$t('global.monthNames.September')}}</option>-->
                <!--<option value="10">{{$t('global.monthNames.October')}}</option>-->
                <!--<option value="11">{{$t('global.monthNames.November')}}</option>-->
                <!--<option value="12">{{$t('global.monthNames.December')}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->


                <div class="row form-group">
                  <div class="col col-md-3"><label class=" form-control-label"></label></div>
                  <div class="col-12 col-md-9">
                    <button class="btn btn-primary" v-on:click="exportInvoices">{{$t('InvoicenInboundExport.exportInvoices')}}</button>
                  </div>

                </div>
                <br>
                <br>

                <div class="row form-group">
                  <!--<div class="col col-12"><label for="datetype" class="form-control-label">{{$t('InvoicenInboundExport.lastmessage')}}</label></div>-->
                </div>
                <div class="row form-group">
                  <div class="col-12 ">
                    <!--isValid-->
                    <!--validationErrors-->
                    <!--errFields-->
                    <!--<template v-if="!isValid">-->
                      <!--<div class=""><textarea readonly disabled rows="6" class="alert-danger w100 messageContainer">{{validationErrorMessages}}</textarea></div>-->
                    <!--</template>-->
                    <!--<template v-if="isValid">-->
                      <!--<div class=""><textarea readonly disabled rows="3" class=" w100 messageContainer">{{validationErrorMessages}}</textarea></div>-->
                    <!--</template>-->
                  </div>


                </div>

              </div>
              <br>
              <br>
              <br>
              <br>
              <br>
              <br>


            </div>

            <div class="card-footer text-center fFix">
            </div>
          </div>

        </div><!-- .animated -->


        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div>
      <!--.content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>
  /*
   * window.db.query("SELECT barcode, amount, article_code, article_name  FROM invoice right join shop on shop.s01=invoice.S1 AND shop.eur=invoice.price AND shop.article_code=invoice.prod_code AND shop.apu=invoice.cont AND shop.amount=invoice.numb ",null, function(){})
   * */



  //  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import InputText from '@/components/InputText.vue';
  //  import i18n from '@/i18n';
  //    import XLSX from 'xlsx';
  //    import OSheetManager from '@/helper/oSheetManager';
  import moment from 'moment';
    import {saveAs} from 'file-saver';
  //    const {ipcRenderer} = require('electron');

  import HelperNavExportXml from "@/helper/HelperNavExportXml";
  //  const log = require('electron-log');
  //  const libxmljs = require('libxmljs');
  import xsdNavExport from '@/helper/xsdNavExport';
  //  const {dialog} = require('electron').remote
  //  const fs = require('fs');

//  const libxmljs = require('libxmljs');
//  import libxmljs from 'libxmljs';
  import User from '@/components/User.vue';
  import LeftMenu from '@/components/LeftMenu.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';

  export default {
    name: 'InvoicenInboundExport',
    data() {
      return {
//                keyboardEnable: true,
        data: {
          datetype: "2",
          dt_from: moment.utc().local().add(-1, 'month').format('YYYY-MM-DD'),
          dt_to: moment.utc().local().format('YYYY-MM-DD'),
        },
        packs: [
          {key: '1', value: 'global.money'},
          {key: '2', value: 'global.pc'},
          {key: '3', value: 'global.kg'},
          {key: '4', value: 'global.l'},
          {key: '5', value: 'global.m'},
          {key: '6', value: 'global.pack'},
          {key: '7', value: 'global.occasion'},
        ],
        year: "",
        yearOptions: [],
        month: "",
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        },
        invoices: [],
        isValid: true,
        validationErrors: [],
        errFields: "",
        validationErrorMessages: ""

        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""

      };
    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
//          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },


      validationErrors: function (newData, oldData) {
        const modul = this;
        modul.validationErrorMessages = "";
        const validationErrorMessages = [];
        if (Array.isArray(newData)) {
          Array.prototype.forEach.call(newData, function (e) {
            validationErrorMessages.push(e.message);
          });
        }
        modul.validationErrorMessages = validationErrorMessages.join(", ");
      },
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [18,19,20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.setYearsMonths();
      },
      setYearsMonths(){
        const modul = this;
        const actualYears = [moment().get("year"), moment().get("year") - 1, moment().get("year") - 2];
        const actualMonth = moment().get("month") + 1;
//                const actualYears = [moment.utc().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
//                const actualMonth = moment.utc().get("month") + 1;
        const yearOptions = [];
        Array.prototype.forEach.call(actualYears, function (e) {
          yearOptions.push({'value': e, 'text': e});
        });
        const selectedYear = "" + actualYears[0];
        const selectedMonth = "" + actualMonth;
        modul.yearOptions = yearOptions;
//                modul.year = selectedYear;
//                modul.month = selectedMonth;

        const actualDt2 = moment();
        actualDt2.subtract('months', 1);
        actualDt2.set('date', 1);
        actualDt2.set('hour', 0);
        actualDt2.set('minute', 0);
        actualDt2.set('second', 0);
        actualDt2.set('millisecond', 0);
        modul.data.dt_from = actualDt2.clone().format('YYYY-MM-DD HH:mm:ss');
        modul.data.dt_to = actualDt2.clone().endOf('month').format('YYYY-MM-DD HH:mm:ss');
        modul.year = actualDt2.get("year");
        modul.month = actualDt2.get("month");
      },

      getSelectedYearMonth(){
        const modul = this;
        let date = "";
        date += modul.year + "-";
        if (modul.month < 10) {
          date += "0" + modul.month + "-";
        } else {
          date += "0" + modul.month + "-";
        }
//                if (modul.uplselDay < 10) {
//                    date += "0" + modul.uplselDay;
//                } else {
//                    date += "0" + modul.uplselDay;
//                }
        return date;
      },
      getFilenameFilter(){
        const modul = this;
        return window.db.quote(modul.data.dt_from) + "-" + window.db.quote(modul.data.dt_to);
      },

      exportInvoices: function (cb) {
        const modul = this;

        modul.getInvoices(function (err, res) {
          if (modul.invoices) {




            if (modul.invoices.length < 1) {
              modul.AlertInPage.msg = "InvoicenInboundExport.errorNoExportData";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));
              return;
            } else {

              let isValid = true;
              let xml = "";
              return new Promise((resolve, reject) => {
                resolve();
              })
              // getVats -- fill
                .then(function (result) {
                    return new Promise((resolve, reject) => {

                        const data = {};
                        data.dt_from = modul.data.dt_from;
                        data.dt_to = modul.data.dt_to;
                        data.packs = modul.packs;
                        data.payment_types = {
                          paymenttype1: modul.$t('invoice.paymenttype1'),
                          paymenttype2: modul.$t('invoice.paymenttype2'),
                          paymenttype3: modul.$t('invoice.paymenttype3'),
                        }
                        const xmlDataObject = HelperNavExportXml.convertInvoiceDatasToXmlDataObject(modul.invoices, data);
                        xml = HelperNavExportXml.getXml(xmlDataObject);
                        console.log(xml);
                        let isValid = true;


                        //
//                        const xsdDoc = libxmljs.parseXmlString(xsdNavExport);
//                        const xmlDoc = libxmljs.parseXmlString(xml);
//                        const result = xmlDoc.validate(xsdDoc);
//
//                        const arg = {};
//                        arg.isValid = result;
//                        arg.validationErrors = xmlDoc.validationErrors;
//                        arg.errFields = xmlDoc.errFields;
//
//                        console.log("----------------XML_VALIDATOR_MESSAGE---------------");
//                        console.log(arg.isValid);
//                        console.log(arg.validationErrors);
//                        console.log(arg.errFields);
//
//                        modul.isValid = true;
//                        modul.validationErrors = [];
//                        modul.errFields = "";
//
//                        isValid = !!arg.isValid;
//                        modul.isValid = arg.isValid;
//                        if (Array.isArray(arg.validationErrors)) {
//                          modul.validationErrors = arg.validationErrors;
//                        }
//                        modul.errFields = arg.errFields;


                        if (!isValid) {
                          setTimeout(function () {


                            resolve(true)

//                            let options = {
//                              buttons: [modul.$t('global.yes'), modul.$t('global.no')],
//                              message: modul.$t('InvoicenInboundExport.errorInExport'),
//                              type: 'question',
//                              title: '',
//                              defaultId: 0,
//                              cancelId: 1
//                            }
//                            let dialogResponse = dialog.showMessageBox(options)
//                            if (dialogResponse === 0) {
//
//
//                              resolve(true)
//                            } else if (dialogResponse === 1) {
//                              reject(false)
//                            } else {
//                              reject(false)
//                            }
                          }, Number(300));

                        } else {

                          resolve(true)

                        }
                      }
                    );
                  }
                  , function (rejectParams) {
                    reject(rejectParams)
                  }
                ).then(function (result) {
                    return new Promise((resolve, reject) => {

                        let filename = 'export.xml';
                        const content = xml; //new Blob([s2ab(xml)]);

                            saveAs(new Blob([xml], {type: "text/plain;charset=utf-8"}), filename); // utf8

//                        const savePath = dialog.showSaveDialog({
//                            title: "",
//                            defaultPath: filename,
//                            filters: [{
//                              name: 'XML',
//                              extensions: ['xml']
//                            }]
//                          }
//                        );
//                        console.log(savePath);
//                        if (savePath !== undefined) {
//                          fs.writeFile(savePath, content, function (err) {
//                            // file saved or err
//                            console.log("Kész")
//                            if (isValid) {
//                              setTimeout(function (e) {
//                                modul.AlertInPage.msg = "global.success";
//                                modul.AlertInPage.type = "success";
//                                setTimeout(function (e) {
//                                  modul.AlertInPage.msg = "";
//                                }, Number(5000));
//                              }, Number(300));
//
//                            } else {
//                              setTimeout(function (e) {
//                                modul.AlertInPage.msg = "global.error";
//                                modul.AlertInPage.type = "danger";
//                                setTimeout(function (e) {
//                                  modul.AlertInPage.msg = "";
//                                }, Number(5000));
//                              }, Number(300));
//                            }
//                          });
//                        }


                      }
                    );
                  }
                  , function (rejectParams) {
                    console.log(rejectParams);
//                    reject(rejectParams)
                  }
                );


            }

          }
        })
      },


//            exportInvoices: function (cb) {
//                const modul = this;
//                modul.getInvoices(function () {
//                    if (modul.invoices) {
//
//                        if (modul.invoices.length < 1) {
//                            modul.AlertInPage.msg = "InvoicenInboundExport.errorNoExportData";
//                            modul.AlertInPage.type = "danger";
//                            setTimeout(function (e) {
//                                modul.AlertInPage.msg = "";
//                            }, Number(5000));
//                            return;
//                        } else {
//
//                            const data = {};
//                            data.dt_from = modul.data.dt_from;
//                            data.dt_to = modul.data.dt_to;
//                            data.packs = modul.packs;
//                            data.payment_types = {
//                                paymenttype1: modul.$t('invoice.paymenttype1'),
//                                paymenttype2: modul.$t('invoice.paymenttype2'),
//                                paymenttype3: modul.$t('invoice.paymenttype3'),
//                            }
//                            const xmlDataObject = HelperNavExportXml.convertInvoiceDatasToXmlDataObject(modul.invoices, data);
//                            const xml = HelperNavExportXml.getXml(xmlDataObject);
//                            console.log(xml);
//
//
//                            const xsdDoc = libxmljs.parseXmlString(xsdNavExport);
//                            const xmlDoc = libxmljs.parseXmlString(xml);
//                            const result = xmlDoc.validate(xsdDoc);
//
//                            const arg = {};
//                            arg.isValid = result;
//                            arg.validationErrors = xmlDoc.validationErrors;
//                            arg.errFields = xmlDoc.errFields;
//
//                            console.log(arg.isValid);
//                            console.log(arg.validationErrors);
//                            console.log(arg.errFields);
//
//                            let filename = 'export.xml';
//
//                            function s2ab(s) {
//                                const buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
//                                const view = new Uint8Array(buf);  //create uint8array as viewer
//                                for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
//                                return buf;
//                            }
//
////                            saveAs(new Blob([s2ab(xml)], {type: "text/xml"}), filename); // ansi
//                            saveAs(new Blob([xml], {type: "text/plain;charset=utf-8"}), filename); // utf8
//
////                            setTimeout(function (e) {
////                                modul.AlertInPage.msg = "global.success";
////                                modul.AlertInPage.type = "success";
////                                setTimeout(function (e) {
////                                    modul.AlertInPage.msg = "";
////                                }, Number(5000));
////                            }, Number(300));
//
//                        }
//
//                    }
//                })
//            },
      getInvoices: function (cbx) {
        const modul = this;

        let fieldname = "dt_make";
        if (Number(modul.datetype) === 1) {
          fieldname = "dt_completion";
        }
        if (Number(modul.datetype) === 2) {
          fieldname = "dt_make";
        }
        if (Number(modul.datetype) === 3) {
          fieldname = "dt_paymentdeadline";
        }
        if (Number(modul.datetype) === 4) {
          fieldname = "dt_needtransfer";
        }
        if (Number(modul.datetype) === 5) {
          fieldname = "dt_transfer";
        }

        const req = {};
        req.data = {};
        req.data.dt_from = modul.data.dt_from;
        req.data.dt_to = modul.data.dt_to;
        req.data.fieldname = fieldname;
        req.id_company = modul.state.id_company;

        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";

        Api.getInvoiceInboundsExport(req).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
            modul.invoices = res.data;
//            modul.data = (res.data.invoiceinbound) ? res.data.invoiceinbound : modul.dataDefault;

            if (typeof cbx === "function") {
              cbx();
            }
          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "";
        });

//        const cb = function (err, res) {
//          if (!err) {
//            modul.getInvoiceElements(cbx, res);
//          } else {
//            // error in query
//            console.log("error in query");
//          }
//        };


//        window.db.select(
//          function (err, res) {
//            cb(err, window.db.convertResToArray(err, res))
//          }
//          , "invoice", "*", "invoice." + fieldname + " >= " + window.db.quote(modul.data.dt_from) + " AND invoice." + fieldname + " <= " + window.db.quote(modul.data.dt_to) + " AND (`definitive` = 1 OR `definitive` = '1') AND (invoice.`deleted` = 0 OR invoice.`deleted` = '0')")
//

      },
      getInvoiceElements: function (cbx, resx) {
        const modul = this;
        if (Array.isArray(resx) && resx.length > 0) {
          const length = resx.length;
          let counter = 0;
          const cb = function (err, res, id) {
            counter++;
            if (Array.isArray(res)) {
              const objectIndex = Helper.getObjectIndexByIdFromObjectArray(modul.invoices, id);
              modul.invoices[objectIndex].invoice_element = res;
            }
            if (counter === length) {
              cbx(modul.invoices);
            }
          };
          modul.invoices = resx;
          Array.prototype.forEach.call(modul.invoices, function (e, i) {
            modul.getInvoiceElementsById(cb, e.id);
          })
        } else {
          cbx(true, resx)
        }
      },
      getInvoiceElementsById: function (cb, id) {
        window.db.select(
          function (err, res) {
            cb(err, window.db.convertResToArray(err, res), id)
          }
          , "invoice_element", "*", "`id_invoice` = " + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0')");
      },
      getPack(packKey){
        const modul = this;
        let ret = "";
        Array.prototype.forEach.call(modul.packs, function (e, i) {
          if (e.key === packKey) {
            ret = e.value;
          }
        });
        return ret;
      },
    },
    components: {
      InputText,
      LngChooser,
      AlertInPage,
      MenuToggle,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      LeftMenu,
      User
    },
  };
</script>
<style>
  .dateSelectsContainer > div {
    float: right;
  }
</style>
